import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const FAQ_ITEMS = [
  {
    q: "Gold üyelik ücreti nedir?",
    a: "Gold üyelik aylık ₺499 veya yıllık ₺4.788 (aylık ₺399) olarak sunulmaktadır. Yıllık planla %20 tasarruf edersiniz. Tüm fiyatlara KDV dahildir.",
  },
  {
    q: "Gold üyeliği nasıl aktif edilir?",
    a: "Formu doldurduktan sonra ekibimiz 24 saat içinde sizinle iletişime geçer. Ödeme onayının ardından Gold rozetiniz aynı gün aktif edilir. Herhangi bir teknik işlem yapmanıza gerek yoktur.",
  },
  {
    q: "Gold üyeliği iptal edebilir miyim?",
    a: "Evet, istediğiniz zaman iptal edebilirsiniz. Aylık planda bir sonraki fatura döneminden itibaren, yıllık planda ise 30 gün içinde iptal talebinde bulunursanız tam iade yapılır.",
  },
  {
    q: "Ücretsiz üyeyim, Gold'a nasıl geçerim?",
    a: "Formu doldururken 'Mevcut Üyelik Durumu' alanında 'Evet, ücretsiz üyeyim' seçeneğini işaretleyin. Ekibimiz mevcut listenizi Gold'a yükseltir — yeni başvuru yapmanıza gerek yoktur.",
  },
  {
    q: "Gold rozeti ne zaman görünmeye başlar?",
    a: "Ödeme onayından sonra genellikle 2-4 saat içinde altın rozetiniz ve 'Öne Çıkan İşletme' etiketiniz aktif olur. Konaklama listesinde üst sıralara taşınırsınız.",
  },
  {
    q: "Gold üyeliğin süresi dolunca ne olur?",
    a: "Gold üyeliğiniz sona erdiğinde rozetiniz ve öne çıkan etiketiniz kaldırılır, ancak ücretsiz listeniz aktif kalmaya devam eder. Yenileme için ekibimiz sizi önceden bilgilendirir.",
  },
  {
    q: "Birden fazla işletmem var, hepsi için Gold alabilir miyim?",
    a: "Evet, her işletme için ayrı Gold üyelik alabilirsiniz. Birden fazla işletme için başvuruda özel paket fiyatlandırması için ekibimizle iletişime geçin.",
  },
  {
    q: "Gold üyeliğin gerçekten farkı var mı?",
    a: "Gold üyeler ortalama 3 kat daha fazla görüntülenme ve %60 daha fazla rezervasyon formu doldurulması alıyor. Öne çıkan slider, liste başı sıralama ve altın rozet ziyaretçilerin dikkatini doğrudan çekiyor.",
  },
];

const FaqAccordion = () => {
  const [openIdx, setOpenIdx] = useState<number | null>(null);
  return (
    <div className="space-y-3">
      {FAQ_ITEMS.map((item, i) => (
        <div
          key={i}
          className={`rounded-2xl border transition-all duration-200 overflow-hidden ${
            openIdx === i ? "border-amber-300 bg-amber-50/50" : "border-stone-100 bg-white hover:border-stone-200"
          }`}
        >
          <button
            onClick={() => setOpenIdx(openIdx === i ? null : i)}
            className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
          >
            <span className={`text-sm font-semibold pr-4 ${openIdx === i ? "text-amber-800" : "text-stone-800"}`}>
              {item.q}
            </span>
            <div className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all ${
              openIdx === i ? "bg-amber-500 text-white rotate-45" : "bg-stone-100 text-stone-500"
            }`}>
              <i className="ri-add-line text-sm"></i>
            </div>
          </button>
          {openIdx === i && (
            <div className="px-5 pb-5">
              <div className="h-px bg-amber-200 mb-4"></div>
              <p className="text-stone-600 text-sm leading-relaxed">{item.a}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

const cities = [
  "İstanbul", "Ankara", "İzmir", "Antalya", "Bursa", "Adana", "Gaziantep",
  "Konya", "Mersin", "Diyarbakır", "Kayseri", "Eskişehir", "Trabzon",
  "Nevşehir (Kapadokya)", "Muğla (Bodrum/Marmaris)", "Denizli (Pamukkale)",
  "Mardin", "Şanlıurfa", "Van", "Erzurum", "Rize", "Artvin", "Bolu",
  "Sakarya", "Çanakkale", "Edirne", "Balıkesir", "Aydın", "Manisa",
];

const goldFeatures = [
  {
    icon: "ri-vip-crown-fill",
    color: "text-amber-500",
    bg: "bg-amber-50",
    title: "Altın Rozet & Öne Çıkan Etiketi",
    desc: "Konaklama listesinde kartınız altın çerçeve, taç rozeti ve 'Öne Çıkan İşletme' etiketiyle öne çıkar. Ziyaretçilerin ilk dikkatini çeken işletme siz olursunuz.",
  },
  {
    icon: "ri-arrow-up-circle-fill",
    color: "text-amber-500",
    bg: "bg-amber-50",
    title: "Liste Başı Sıralama",
    desc: "Arama ve filtreleme sonuçlarında Gold üyeler her zaman ücretsiz üyelerin önünde listelenir. Görünürlüğünüz maksimuma çıkar.",
  },
  {
    icon: "ri-star-fill",
    color: "text-amber-500",
    bg: "bg-amber-50",
    title: "Öne Çıkan Slider'da Yer",
    desc: "Konaklama sayfasının üst kısmındaki öne çıkan işletmeler slider'ında yer alırsınız. Binlerce ziyaretçi sizi ilk sırada görür.",
  },
  {
    icon: "ri-shield-check-fill",
    color: "text-emerald-500",
    bg: "bg-emerald-50",
    title: "Güvenilir İşletme Rozeti",
    desc: "Detay sayfanızda 'Gold Üye — Güvenilir İşletme' rozeti görünür. Misafirler güvenle rezervasyon yapar.",
  },
  {
    icon: "ri-customer-service-2-fill",
    color: "text-stone-600",
    bg: "bg-stone-100",
    title: "Öncelikli Destek",
    desc: "Bilgi güncelleme, fotoğraf ekleme ve içerik düzenleme talepleriniz 24 saat içinde işleme alınır.",
  },
  {
    icon: "ri-bar-chart-2-fill",
    color: "text-stone-600",
    bg: "bg-stone-100",
    title: "Aylık Görüntülenme Raporu",
    desc: "İşletmenizin kaç kişi tarafından görüntülendiğini, kaç rezervasyon formu doldurulduğunu aylık rapor olarak alırsınız.",
  },
];

const comparisonRows = [
  { feature: "Konaklama listesinde listeleme", free: true, gold: true },
  { feature: "Harita üzerinde görünürlük", free: true, gold: true },
  { feature: "Rezervasyon formu", free: true, gold: true },
  { feature: "Telefon numarası gösterimi", free: true, gold: true },
  { feature: "Altın rozet & taç ikonu", free: false, gold: true },
  { feature: "'Öne Çıkan İşletme' etiketi", free: false, gold: true },
  { feature: "Liste başı sıralama", free: false, gold: true },
  { feature: "Öne çıkan slider'da yer", free: false, gold: true },
  { feature: "Güvenilir işletme rozeti", free: false, gold: true },
  { feature: "Öncelikli destek (24 saat)", free: false, gold: true },
  { feature: "Aylık görüntülenme raporu", free: false, gold: true },
];

const GoldApplyPage = () => {
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [form, setForm] = useState({
    businessName: "",
    ownerName: "",
    email: "",
    phone: "",
    city: "",
    currentMember: "",
    message: "",
    acceptTerms: false,
  });

  const update = (field: string, value: string | boolean) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.acceptTerms) return;
    setSubmitting(true);

    // Gold başvurusunu localStorage'a kaydet
    const goldSubmissions = JSON.parse(localStorage.getItem("goldSubmissions") || "[]");
    const newGoldSub = {
      id: `gold-${Date.now()}`,
      type: "gold",
      name: form.businessName,
      ownerName: form.ownerName,
      email: form.email,
      phone: form.phone,
      city: form.city,
      extra: form.currentMember || "",
      status: "pending",
      appliedAt: new Date().toISOString(),
      message: form.message,
    };
    localStorage.setItem("goldSubmissions", JSON.stringify([newGoldSub, ...goldSubmissions]));

    // Admin bildirim e-postası
    const adminEmail = localStorage.getItem("adminNotifEmail") || "admin@geziturkiyem.com";
    const adminSubject = `Yeni Gold Üyelik Talebi: ${form.businessName}`;
    const adminBody = `Yeni bir Gold üyelik talebi alındı!\n\nİşletme: ${form.businessName}\nŞehir: ${form.city}\nSahibi: ${form.ownerName}\nE-posta: ${form.email}\nTelefon: ${form.phone}\nMevcut Üyelik: ${form.currentMember || "Belirtilmedi"}\nMesaj: ${form.message || "—"}\n\nAdmin panelinden inceleyebilirsiniz:\nhttps://geziturkiyem.com/admin`;
    window.open(`mailto:${adminEmail}?subject=${encodeURIComponent(adminSubject)}&body=${encodeURIComponent(adminBody)}`, "_blank");

    const body = new URLSearchParams();
    body.append("businessName", form.businessName);
    body.append("ownerName", form.ownerName);
    body.append("email", form.email);
    body.append("phone", form.phone);
    body.append("city", form.city);
    body.append("currentMember", form.currentMember);
    body.append("message", form.message);

    try {
      await fetch("https://readdy.ai/api/form/d7d654s5q56ra7tuffug", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
    } catch {
      // silent
    }

    setTimeout(() => {
      setSubmitting(false);
      setSubmitted(true);
    }, 1200);
  };

  if (submitted) {
    return (
      <div className="min-h-screen bg-white">
        <Navbar />
        <div className="min-h-screen flex items-center justify-center px-4 pt-20">
          <div className="max-w-md w-full text-center">
            <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6 bg-amber-100 rounded-full">
              <i className="ri-vip-crown-fill text-amber-500 text-4xl"></i>
            </div>
            <h1 className="text-2xl font-bold text-stone-900 mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
              Gold Başvurunuz Alındı!
            </h1>
            <p className="text-stone-500 text-sm leading-relaxed mb-2">
              <strong>{form.businessName}</strong> için Gold üyelik talebiniz iletildi.
            </p>
            <p className="text-stone-400 text-sm leading-relaxed mb-8">
              Ekibimiz <strong>{form.email}</strong> adresinize en kısa sürede ulaşacak ve Gold üyelik detaylarını paylaşacaktır.
            </p>
            <div className="bg-gradient-to-br from-amber-50 to-yellow-50 border border-amber-200 rounded-2xl p-5 mb-8">
              <div className="flex items-center gap-2 mb-3">
                <i className="ri-vip-crown-fill text-amber-500"></i>
                <span className="text-sm font-bold text-amber-800">Gold Üyelik Avantajları Sizi Bekliyor</span>
              </div>
              <ul className="text-xs text-amber-700 space-y-1.5 text-left">
                <li className="flex items-center gap-2"><i className="ri-check-line text-amber-500"></i> Altın rozet &amp; Öne Çıkan etiketi</li>
                <li className="flex items-center gap-2"><i className="ri-check-line text-amber-500"></i> Liste başı sıralama</li>
                <li className="flex items-center gap-2"><i className="ri-check-line text-amber-500"></i> Öne çıkan slider&apos;da yer</li>
                <li className="flex items-center gap-2"><i className="ri-check-line text-amber-500"></i> Öncelikli destek</li>
              </ul>
            </div>
            <div className="flex gap-3 justify-center">
              <Link to="/accommodations" className="px-6 py-2.5 bg-stone-900 text-white text-sm font-semibold rounded-xl hover:bg-stone-700 transition-colors cursor-pointer whitespace-nowrap">
                Konaklama Rehberi
              </Link>
              <Link to="/" className="px-6 py-2.5 border border-stone-200 text-stone-700 text-sm font-semibold rounded-xl hover:bg-stone-50 transition-colors cursor-pointer whitespace-nowrap">
                Ana Sayfa
              </Link>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <div className="relative pt-20 pb-16 overflow-hidden" style={{ background: "linear-gradient(135deg, #1c1917 0%, #292524 60%, #1c1917 100%)" }}>
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=luxury%20five%20star%20hotel%20golden%20interior%20elegant%20chandelier%20warm%20amber%20lighting%20premium%20accommodation%20Turkey%20boutique%20grand%20lobby%20opulent&width=1400&height=600&seq=gold-apply-hero&orientation=landscape"
            alt="Gold Üyelik"
            className="w-full h-full object-cover object-top opacity-20"
          />
        </div>
        {/* Gold shimmer overlay */}
        <div className="absolute inset-0" style={{ background: "radial-gradient(ellipse at 50% 0%, rgba(245,158,11,0.15) 0%, transparent 70%)" }}></div>

        <div className="relative max-w-4xl mx-auto px-4 md:px-8 text-center">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-amber-500 to-yellow-400 text-white text-xs font-bold px-5 py-2 rounded-full mb-6 uppercase tracking-widest">
            <i className="ri-vip-crown-fill"></i>
            Gold Üyelik
          </div>
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
            İşletmenizi Öne Çıkarın,<br />
            <span className="text-amber-400">Daha Fazla Misafir Kazanın</span>
          </h1>
          <p className="text-stone-300 text-sm md:text-base max-w-xl mx-auto leading-relaxed mb-8">
            Gold üyelik ile konaklama listesinde ilk sırada yer alın. Altın rozet, öne çıkan etiketi ve öncelikli görünürlükle rakiplerinizden ayrışın.
          </p>

          {/* Quick stats */}
          <div className="flex flex-wrap items-center justify-center gap-6 mt-8">
            {[
              { value: "3x", label: "Daha Fazla Görüntülenme" },
              { value: "%60", label: "Daha Fazla Rezervasyon" },
              { value: "1 Yıl", label: "Gold Üyelik Süresi" },
            ].map((s) => (
              <div key={s.label} className="text-center">
                <p className="text-2xl font-bold text-amber-400" style={{ fontFamily: "'Playfair Display', serif" }}>{s.value}</p>
                <p className="text-stone-400 text-xs mt-0.5">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Gold Features */}
      <div className="py-16 bg-white">
        <div className="max-w-5xl mx-auto px-4 md:px-8">
          <div className="text-center mb-12">
            <span className="inline-block bg-amber-100 text-amber-700 text-xs font-semibold px-4 py-1.5 rounded-full mb-3 uppercase tracking-widest">
              Gold Avantajları
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-stone-900" style={{ fontFamily: "'Playfair Display', serif" }}>
              Gold Üyeliğin Farkı
            </h2>
            <p className="text-stone-400 text-sm mt-3 max-w-lg mx-auto">
              Ücretsiz üyeliğin ötesine geçin. Gold üyeler ortalama 3 kat daha fazla görüntülenme alıyor.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {goldFeatures.map((f) => (
              <div key={f.title} className="bg-stone-50 rounded-2xl p-5 hover:bg-amber-50/50 transition-colors group border border-transparent hover:border-amber-100">
                <div className={`w-11 h-11 flex items-center justify-center rounded-xl mb-4 ${f.bg}`}>
                  <i className={`${f.icon} text-xl ${f.color}`}></i>
                </div>
                <h3 className="font-bold text-stone-900 text-sm mb-2">{f.title}</h3>
                <p className="text-stone-500 text-xs leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Pricing Section */}
      <div className="py-16 bg-stone-900 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <img src="https://readdy.ai/api/search-image?query=gold%20luxury%20abstract%20shimmer%20texture%20premium%20dark%20background%20warm%20amber%20glow%20elegant&width=1400&height=600&seq=pricing-bg-gold&orientation=landscape" alt="" className="w-full h-full object-cover object-top" />
        </div>
        <div className="absolute inset-0" style={{ background: "radial-gradient(ellipse at 50% 0%, rgba(245,158,11,0.12) 0%, transparent 70%)" }}></div>
        <div className="relative max-w-4xl mx-auto px-4 md:px-8">
          <div className="text-center mb-12">
            <span className="inline-block bg-amber-500/20 border border-amber-400/30 text-amber-300 text-xs font-semibold px-4 py-1.5 rounded-full mb-3 uppercase tracking-widest">
              Fiyatlandırma
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-white" style={{ fontFamily: "'Playfair Display', serif" }}>
              Şeffaf & Uygun Fiyatlar
            </h2>
            <p className="text-stone-400 text-sm mt-3 max-w-lg mx-auto">
              İşletmenizin büyüklüğüne göre en uygun planı seçin. İstediğiniz zaman iptal edebilirsiniz.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {/* Free Plan */}
            <div className="bg-white/5 border border-white/10 rounded-2xl p-6 flex flex-col">
              <div className="mb-5">
                <div className="w-10 h-10 flex items-center justify-center bg-stone-700 rounded-xl mb-4">
                  <i className="ri-user-line text-stone-300 text-lg"></i>
                </div>
                <p className="text-stone-300 text-xs font-semibold uppercase tracking-widest mb-1">Ücretsiz</p>
                <div className="flex items-end gap-1 mb-1">
                  <span className="text-4xl font-bold text-white" style={{ fontFamily: "'Playfair Display', serif" }}>₺0</span>
                  <span className="text-stone-400 text-sm mb-1.5">/ay</span>
                </div>
                <p className="text-stone-500 text-xs">Sonsuza kadar ücretsiz</p>
              </div>
              <ul className="space-y-2.5 flex-1 mb-6">
                {["Konaklama listesinde listeleme", "Harita görünümü", "Rezervasyon formu", "Telefon gösterimi"].map((f) => (
                  <li key={f} className="flex items-center gap-2 text-xs text-stone-400">
                    <i className="ri-check-line text-stone-500"></i> {f}
                  </li>
                ))}
                {["Altın rozet", "Liste başı sıralama", "Öne çıkan slider"].map((f) => (
                  <li key={f} className="flex items-center gap-2 text-xs text-stone-600 line-through">
                    <i className="ri-close-line text-stone-700"></i> {f}
                  </li>
                ))}
              </ul>
              <Link to="/hotel-apply" className="block text-center py-2.5 border border-stone-600 text-stone-400 text-sm font-semibold rounded-xl hover:border-stone-400 hover:text-stone-300 transition-colors cursor-pointer whitespace-nowrap">
                Ücretsiz Başvur
              </Link>
            </div>

            {/* Monthly Gold */}
            <div className="bg-white/5 border border-amber-400/30 rounded-2xl p-6 flex flex-col relative">
              <div className="mb-5">
                <div className="w-10 h-10 flex items-center justify-center bg-amber-500/20 rounded-xl mb-4">
                  <i className="ri-vip-crown-fill text-amber-400 text-lg"></i>
                </div>
                <p className="text-amber-400 text-xs font-semibold uppercase tracking-widest mb-1">Gold — Aylık</p>
                <div className="flex items-end gap-1 mb-1">
                  <span className="text-4xl font-bold text-white" style={{ fontFamily: "'Playfair Display', serif" }}>₺499</span>
                  <span className="text-stone-400 text-sm mb-1.5">/ay</span>
                </div>
                <p className="text-stone-500 text-xs">KDV dahil · İstediğiniz zaman iptal</p>
              </div>
              <ul className="space-y-2.5 flex-1 mb-6">
                {["Tüm ücretsiz özellikler", "Altın rozet & taç ikonu", "Liste başı sıralama", "Öne çıkan slider'da yer", "Güvenilir işletme rozeti", "Öncelikli destek (24 saat)"].map((f) => (
                  <li key={f} className="flex items-center gap-2 text-xs text-stone-300">
                    <i className="ri-check-line text-amber-400"></i> {f}
                  </li>
                ))}
              </ul>
              <button
                onClick={() => document.getElementById("gold-form")?.scrollIntoView({ behavior: "smooth" })}
                className="block text-center py-2.5 bg-amber-500/20 border border-amber-400/50 text-amber-300 text-sm font-semibold rounded-xl hover:bg-amber-500/30 transition-colors cursor-pointer whitespace-nowrap"
              >
                Aylık Başvur
              </button>
            </div>

            {/* Yearly Gold — Best Value */}
            <div className="relative rounded-2xl p-6 flex flex-col overflow-hidden" style={{ background: "linear-gradient(135deg, rgba(245,158,11,0.25) 0%, rgba(234,179,8,0.15) 100%)", border: "1px solid rgba(245,158,11,0.5)" }}>
              {/* Best value badge */}
              <div className="absolute top-4 right-4 bg-gradient-to-r from-amber-500 to-yellow-400 text-white text-xs font-bold px-3 py-1 rounded-full">
                En Avantajlı
              </div>
              <div className="mb-5">
                <div className="w-10 h-10 flex items-center justify-center bg-amber-500/30 rounded-xl mb-4">
                  <i className="ri-vip-crown-2-fill text-amber-300 text-lg"></i>
                </div>
                <p className="text-amber-300 text-xs font-semibold uppercase tracking-widest mb-1">Gold — Yıllık</p>
                <div className="flex items-end gap-1 mb-1">
                  <span className="text-4xl font-bold text-white" style={{ fontFamily: "'Playfair Display', serif" }}>₺399</span>
                  <span className="text-stone-400 text-sm mb-1.5">/ay</span>
                </div>
                <div className="flex items-center gap-2">
                  <p className="text-stone-400 text-xs">₺4.788/yıl · KDV dahil</p>
                  <span className="bg-emerald-500/20 text-emerald-400 text-xs font-bold px-2 py-0.5 rounded-full">%20 İndirim</span>
                </div>
              </div>
              <ul className="space-y-2.5 flex-1 mb-6">
                {["Tüm aylık Gold özellikleri", "Altın rozet & taç ikonu", "Liste başı sıralama", "Öne çıkan slider'da yer", "Güvenilir işletme rozeti", "Öncelikli destek (24 saat)", "Aylık görüntülenme raporu"].map((f) => (
                  <li key={f} className="flex items-center gap-2 text-xs text-stone-200">
                    <i className="ri-check-line text-amber-400"></i> {f}
                  </li>
                ))}
              </ul>
              <button
                onClick={() => document.getElementById("gold-form")?.scrollIntoView({ behavior: "smooth" })}
                className="block text-center py-2.5 bg-gradient-to-r from-amber-500 to-yellow-400 hover:from-amber-600 hover:to-yellow-500 text-white text-sm font-bold rounded-xl transition-all cursor-pointer whitespace-nowrap"
              >
                Yıllık Başvur — En Avantajlı
              </button>
            </div>
          </div>

          {/* Money back note */}
          <div className="mt-8 flex items-center justify-center gap-3 text-stone-500 text-xs">
            <i className="ri-shield-check-line text-amber-500 text-base"></i>
            <span>30 gün içinde memnun kalmazsanız ücret iadesi yapılır · Kredi kartı gerekmez · İstediğiniz zaman iptal</span>
          </div>
        </div>
      </div>

      {/* Comparison Table */}
      <div className="py-16 bg-stone-50">
        <div className="max-w-3xl mx-auto px-4 md:px-8">
          <div className="text-center mb-10">
            <h2 className="text-2xl font-bold text-stone-900" style={{ fontFamily: "'Playfair Display', serif" }}>
              Ücretsiz vs Gold Karşılaştırması
            </h2>
            <p className="text-stone-400 text-sm mt-2">Hangi üyeliğin size uygun olduğunu görün</p>
          </div>

          <div className="bg-white rounded-2xl border border-stone-100 overflow-hidden">
            {/* Header */}
            <div className="grid grid-cols-3 bg-stone-900 text-white">
              <div className="px-5 py-4 text-sm font-semibold">Özellik</div>
              <div className="px-5 py-4 text-sm font-semibold text-center border-l border-stone-700">Ücretsiz</div>
              <div className="px-5 py-4 text-sm font-bold text-center border-l border-stone-700">
                <div className="flex items-center justify-center gap-1.5">
                  <i className="ri-vip-crown-fill text-amber-400"></i>
                  <span className="text-amber-400">Gold</span>
                </div>
              </div>
            </div>

            {comparisonRows.map((row, i) => (
              <div key={row.feature} className={`grid grid-cols-3 border-b border-stone-50 ${i % 2 === 0 ? "bg-white" : "bg-stone-50/50"}`}>
                <div className="px-5 py-3.5 text-xs text-stone-700 font-medium">{row.feature}</div>
                <div className="px-5 py-3.5 flex items-center justify-center border-l border-stone-100">
                  {row.free
                    ? <i className="ri-check-line text-emerald-500 text-base"></i>
                    : <i className="ri-close-line text-stone-300 text-base"></i>
                  }
                </div>
                <div className="px-5 py-3.5 flex items-center justify-center border-l border-stone-100">
                  {row.gold
                    ? <i className="ri-check-line text-amber-500 text-base font-bold"></i>
                    : <i className="ri-close-line text-stone-300 text-base"></i>
                  }
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Testimonials */}
      <div className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 md:px-8">
          <div className="text-center mb-10">
            <h2 className="text-2xl font-bold text-stone-900" style={{ fontFamily: "'Playfair Display', serif" }}>
              Gold Üyeler Ne Diyor?
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {[
              {
                name: "Mehmet Y.",
                business: "Kapadokya Cave Suites",
                city: "Nevşehir",
                text: "Gold üyeliğe geçtikten sonra rezervasyonlarımız 3 katına çıktı. Öne çıkan etiketi gerçekten işe yarıyor — misafirler bizi ilk görüyor.",
                rating: 5,
                img: "https://readdy.ai/api/search-image?query=professional%20Turkish%20male%20hotel%20manager%20portrait%20confident%20smile%20business%20attire%20warm%20background&width=80&height=80&seq=gold-test-1&orientation=squarish",
              },
              {
                name: "Ayşe D.",
                business: "Mardin Taş Ev Pansiyon",
                city: "Mardin",
                text: "Altın rozet sayesinde ziyaretçiler bize daha güvenle ulaşıyor. Aylık rapor da çok faydalı — hangi günler daha fazla görüntülendiğimizi görüyoruz.",
                rating: 5,
                img: "https://readdy.ai/api/search-image?query=professional%20Turkish%20female%20hotel%20owner%20portrait%20confident%20smile%20business%20attire%20warm%20background&width=80&height=80&seq=gold-test-2&orientation=squarish",
              },
            ].map((t) => (
              <div key={t.name} className="bg-stone-50 rounded-2xl p-6 border border-stone-100">
                <div className="flex items-center gap-1 mb-4">
                  {[1,2,3,4,5].map((s) => (
                    <i key={s} className="ri-star-fill text-amber-400 text-sm"></i>
                  ))}
                </div>
                <p className="text-stone-600 text-sm leading-relaxed mb-5 italic">&ldquo;{t.text}&rdquo;</p>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                    <img src={t.img} alt={t.name} className="w-full h-full object-cover object-top" />
                  </div>
                  <div>
                    <p className="font-semibold text-stone-900 text-sm">{t.name}</p>
                    <p className="text-stone-400 text-xs">{t.business} · {t.city}</p>
                  </div>
                  <div className="ml-auto flex items-center gap-1 bg-gradient-to-r from-amber-500 to-yellow-400 text-white text-xs font-bold px-2.5 py-1 rounded-full">
                    <i className="ri-vip-crown-fill text-xs"></i>
                    Gold
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Application Form */}
      <div id="gold-form" className="py-16 bg-stone-50">
        <div className="max-w-2xl mx-auto px-4 md:px-8">
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-amber-500 to-yellow-400 text-white text-xs font-bold px-5 py-2 rounded-full mb-4 uppercase tracking-widest">
              <i className="ri-vip-crown-fill"></i>
              Gold Başvurusu
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-stone-900" style={{ fontFamily: "'Playfair Display', serif" }}>
              Gold Üyelik Talep Formu
            </h2>
            <p className="text-stone-400 text-sm mt-3 max-w-md mx-auto">
              Formu doldurun, ekibimiz 24 saat içinde sizinle iletişime geçsin ve Gold üyelik detaylarını paylaşsın.
            </p>
          </div>

          <div className="bg-white rounded-2xl border border-amber-200 overflow-hidden" style={{ boxShadow: "0 0 40px rgba(245,158,11,0.08)" }}>
            {/* Gold header bar */}
            <div className="flex items-center gap-3 px-6 py-4 bg-gradient-to-r from-amber-500 to-yellow-400">
              <i className="ri-vip-crown-fill text-white text-xl"></i>
              <div>
                <p className="text-white font-bold text-sm">Gold Üyelik Başvurusu</p>
                <p className="text-white/80 text-xs">Ekibimiz 24 saat içinde size ulaşacak</p>
              </div>
            </div>

            <form onSubmit={handleSubmit} className="p-6 space-y-5" data-readdy-form>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="sm:col-span-2">
                  <label className="block text-xs font-semibold text-stone-600 mb-1.5">İşletme Adı *</label>
                  <input
                    type="text"
                    name="businessName"
                    required
                    value={form.businessName}
                    onChange={(e) => update("businessName", e.target.value)}
                    placeholder="Örn: Kapadokya Cave Hotel"
                    className="w-full border border-stone-200 rounded-xl px-4 py-3 text-sm text-stone-800 outline-none focus:border-amber-400 transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-stone-600 mb-1.5">Yetkili Adı Soyadı *</label>
                  <input
                    type="text"
                    name="ownerName"
                    required
                    value={form.ownerName}
                    onChange={(e) => update("ownerName", e.target.value)}
                    placeholder="Ad Soyad"
                    className="w-full border border-stone-200 rounded-xl px-4 py-3 text-sm text-stone-800 outline-none focus:border-amber-400 transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-stone-600 mb-1.5">E-posta *</label>
                  <input
                    type="email"
                    name="email"
                    required
                    value={form.email}
                    onChange={(e) => update("email", e.target.value)}
                    placeholder="ornek@email.com"
                    className="w-full border border-stone-200 rounded-xl px-4 py-3 text-sm text-stone-800 outline-none focus:border-amber-400 transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-stone-600 mb-1.5">Telefon *</label>
                  <input
                    type="tel"
                    name="phone"
                    required
                    value={form.phone}
                    onChange={(e) => update("phone", e.target.value)}
                    placeholder="0532 000 00 00"
                    className="w-full border border-stone-200 rounded-xl px-4 py-3 text-sm text-stone-800 outline-none focus:border-amber-400 transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-stone-600 mb-1.5">Şehir *</label>
                  <select
                    name="city"
                    required
                    value={form.city}
                    onChange={(e) => update("city", e.target.value)}
                    className="w-full border border-stone-200 rounded-xl px-4 py-3 text-sm text-stone-800 outline-none focus:border-amber-400 transition-colors bg-white"
                  >
                    <option value="">Şehir seçin</option>
                    {cities.map((c) => <option key={c} value={c}>{c}</option>)}
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-semibold text-stone-600 mb-1.5">Mevcut Üyelik Durumu</label>
                  <select
                    name="currentMember"
                    value={form.currentMember}
                    onChange={(e) => update("currentMember", e.target.value)}
                    className="w-full border border-stone-200 rounded-xl px-4 py-3 text-sm text-stone-800 outline-none focus:border-amber-400 transition-colors bg-white"
                  >
                    <option value="">Seçin</option>
                    <option value="Evet, ücretsiz üyeyim">Evet, ücretsiz üyeyim</option>
                    <option value="Hayır, henüz üye değilim">Hayır, henüz üye değilim</option>
                    <option value="Başvurum inceleniyor">Başvurum inceleniyor</option>
                  </select>
                </div>
              </div>

              <div>
                <label className="block text-xs font-semibold text-stone-600 mb-1.5">Ek Mesaj / Sorularınız</label>
                <textarea
                  name="message"
                  rows={3}
                  maxLength={500}
                  value={form.message}
                  onChange={(e) => update("message", e.target.value)}
                  placeholder="Gold üyelik hakkında sormak istediklerinizi yazın..."
                  className="w-full border border-stone-200 rounded-xl px-4 py-3 text-sm text-stone-800 outline-none focus:border-amber-400 transition-colors resize-none"
                />
                <p className="text-xs text-stone-400 text-right mt-1">{form.message.length}/500</p>
              </div>

              {/* Info box */}
              <div className="bg-amber-50 border border-amber-100 rounded-xl p-4">
                <div className="flex items-start gap-3">
                  <i className="ri-information-line text-amber-500 mt-0.5"></i>
                  <div className="text-xs text-amber-700 leading-relaxed">
                    <strong>Nasıl işliyor?</strong> Formu gönderdikten sonra ekibimiz 24 saat içinde sizinle iletişime geçer, Gold üyelik ücretini ve detaylarını paylaşır. Onayınızın ardından Gold rozetiniz aktif edilir.
                  </div>
                </div>
              </div>

              {/* Terms */}
              <div className="flex items-start gap-3">
                <button
                  type="button"
                  onClick={() => update("acceptTerms", !form.acceptTerms)}
                  className={`w-5 h-5 flex-shrink-0 mt-0.5 rounded border-2 flex items-center justify-center transition-all cursor-pointer ${
                    form.acceptTerms ? "bg-amber-500 border-amber-500" : "border-stone-300"
                  }`}
                >
                  {form.acceptTerms && <i className="ri-check-line text-white text-xs"></i>}
                </button>
                <p className="text-xs text-stone-500 leading-relaxed">
                  Verdiğim bilgilerin doğru olduğunu ve Gold üyelik talebi için ekiple iletişime geçilmesini kabul ediyorum.
                </p>
              </div>

              <button
                type="submit"
                disabled={!form.acceptTerms || submitting}
                className="w-full flex items-center justify-center gap-2 py-3.5 bg-gradient-to-r from-amber-500 to-yellow-500 hover:from-amber-600 hover:to-yellow-600 disabled:opacity-50 disabled:cursor-not-allowed text-white text-sm font-bold rounded-xl transition-all cursor-pointer whitespace-nowrap"
              >
                {submitting ? (
                  <><i className="ri-loader-4-line animate-spin"></i> Gönderiliyor...</>
                ) : (
                  <><i className="ri-vip-crown-fill"></i> Gold Üyelik Talep Et</>
                )}
              </button>
            </form>
          </div>

          {/* FAQ Section */}
          <div className="mt-16">
            <div className="text-center mb-8">
              <span className="inline-block bg-stone-100 text-stone-600 text-xs font-semibold px-4 py-1.5 rounded-full mb-3 uppercase tracking-widest">
                SSS
              </span>
              <h2 className="text-2xl font-bold text-stone-900" style={{ fontFamily: "'Playfair Display', serif" }}>
                Sıkça Sorulan Sorular
              </h2>
              <p className="text-stone-400 text-sm mt-2">Gold üyelik hakkında merak ettikleriniz</p>
            </div>
            <FaqAccordion />
          </div>

          {/* Already member? */}
          <div className="mt-10 text-center">
            <p className="text-stone-400 text-sm">
              Henüz üye değil misiniz?{" "}
              <Link to="/hotel-apply" className="text-amber-600 font-semibold hover:text-amber-700 cursor-pointer">
                Önce ücretsiz üyelik başvurusu yapın
              </Link>
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default GoldApplyPage;
